import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withTranslations } from 'react-utilities';
import { translationConfig } from './app.config';
import DevExWelcomeMessage from './components/developerExchangeWelcomeMessage';

function App({ translate }) {
  return (
    <Fragment>
      <DevExWelcomeMessage translate={translate} />
    </Fragment>
  );
}

App.propTypes = {
  translate: PropTypes.func.isRequired
};

export default withTranslations(App, translationConfig);
